import React from 'react'
import styles from './index.less'
import loading from '@/pages/images/common/loading.png'

/*
@loading组件 SmartLoadingModal

visible:loading是否显示 Boolean

@示例
//
<SmartLoadingModal visible={this.state.visible} />
*/
interface IProps {
  tips: string
  visible: boolean
}
interface IState {
  visibale: boolean
}
export default class SmartLoadingModal extends React.Component<IProps, IState> {
  public state: IState = {
    visibale: this.props.visible
  }

  public static defaultProps = {
    tips: '',
    visible: false
  }

  // static props: any;
  public UNSAFE_componentWillReceiveProps (nextProps: any) {
    this.setState({
      visibale: nextProps.visible
    })
  }

  public render () {
    return (
      <div
        className={
          this.state.visibale
            ? styles.smartLoadingOuter
            : `${styles.smartLoadingOuter} ${styles.loadingHide}`
        }
      >
        <div className={styles['modal-layer']}/>
        <div className={`${styles['modal-inner']} ${styles['loading-inner']}`}>
          <img src={loading} alt='' className={styles.loadImg} />
        </div>
      </div>
    )
  }
}
